// extracted by mini-css-extract-plugin
export default {"imgAbout":"About_imgAbout__oucN6","textAbout":"About_textAbout__+PGxC"};